import { create } from 'zustand';
import { analyticsOptibotStarted } from '@/lib/analytics-service';

interface OptibotState {
  isOpen: boolean;
  isExpanded: boolean;
  showHistory: boolean;
  setOpen: (open: boolean) => void;
  setExpanded: (expanded: boolean) => void;
  setShowHistory: (show: boolean) => void;
  toggle: () => void;
}

export const useOptibotStore = create<OptibotState>((set) => ({
  isOpen: false,
  isExpanded: false,
  showHistory: false,
  setOpen: (isOpen) => {
    if (isOpen) {
      analyticsOptibotStarted({ sourcePage: window.location.pathname });
    }
    set({ isOpen });
  },
  setExpanded: (isExpanded) => set({ isExpanded }),
  setShowHistory: (showHistory) => set({ showHistory }),
  toggle: () =>
    set((state) => {
      if (!state.isOpen) {
        analyticsOptibotStarted({ sourcePage: window.location.pathname });
      }
      return { isOpen: !state.isOpen };
    }),
}));
